import { isToolbarIsFullscreen } from './ToolbarStore';

export const updateToolbarIsFullscreen= (value) => isToolbarIsFullscreen.update((oldValue) => value);
